import { render, staticRenderFns } from "./Pregunta.vue?vue&type=template&id=8e4df5e0"
import script from "./Pregunta.vue?vue&type=script&lang=js"
export * from "./Pregunta.vue?vue&type=script&lang=js"
import style0 from "./Pregunta.vue?vue&type=style&index=0&id=8e4df5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports